module.exports = __webpack_public_path__ + "../resources/img/ic_cancel_primary.64f70db8.svg";